"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _fns = require("@react-pdf/fns");
/**
 * Get attributed string end value
 *
 * @param  {Object}  attributed string
 * @return {number} end
 */


var end = function end(attributedString) {
  var runs = attributedString.runs;
  return runs.length === 0 ? 0 : (0, _fns.last)(runs).end;
};

var _default = end;
exports["default"] = _default;